import React, { useState } from "react";
import InvoiceNumber from "./Main";

const DEFAULT_VALUE = {
  value: "",
  warning: null,
  message: 'Testing'
}

const Demo = () => {
  const [value, setValue] = useState({...DEFAULT_VALUE})

  return (
    <>
      <InvoiceNumber
        default_value={'invoice-0001'}
        value={value}
        // show_message={true}
        onChange={(val) => setValue(val)}
      />
      <br/>
      <br/>
      {value && <ul>
        <li>Value: {value.value}</li>
      </ul>}
    </>
  )
}

export default Demo;
